/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PaxCheckBarcodeToDocMismatch, PaxCheckBarcodeToDocMismatchFromJSONTyped, PaxCheckBarcodeToDocMismatchToJSON } from "./PaxCheckBarcodeToDocMismatch";
import { PaxCheckDocumentTypeNotSupported, PaxCheckDocumentTypeNotSupportedFromJSONTyped, PaxCheckDocumentTypeNotSupportedToJSON } from "./PaxCheckDocumentTypeNotSupported";
import { PaxCheckFileTooLarge, PaxCheckFileTooLargeFromJSONTyped, PaxCheckFileTooLargeToJSON } from "./PaxCheckFileTooLarge";
import { PaxCheckFileTypesNotSupported, PaxCheckFileTypesNotSupportedFromJSONTyped, PaxCheckFileTypesNotSupportedToJSON } from "./PaxCheckFileTypesNotSupported";
import { PaxCheckMrzToVizMismatch, PaxCheckMrzToVizMismatchFromJSONTyped, PaxCheckMrzToVizMismatchToJSON } from "./PaxCheckMrzToVizMismatch";
import { PaxCheckMrzVerificationError, PaxCheckMrzVerificationErrorFromJSONTyped, PaxCheckMrzVerificationErrorToJSON } from "./PaxCheckMrzVerificationError";
import { PaxCheckNoBarcodeScannedError, PaxCheckNoBarcodeScannedErrorFromJSONTyped, PaxCheckNoBarcodeScannedErrorToJSON } from "./PaxCheckNoBarcodeScannedError";
import { PaxCheckNoMrzSideScannedError, PaxCheckNoMrzSideScannedErrorFromJSONTyped, PaxCheckNoMrzSideScannedErrorToJSON } from "./PaxCheckNoMrzSideScannedError";
import { PaxCheckNotAllSidesScannedError, PaxCheckNotAllSidesScannedErrorFromJSONTyped, PaxCheckNotAllSidesScannedErrorToJSON } from "./PaxCheckNotAllSidesScannedError";
import { PaxCheckRecognizedDocumentKindMismatch, PaxCheckRecognizedDocumentKindMismatchFromJSONTyped, PaxCheckRecognizedDocumentKindMismatchToJSON } from "./PaxCheckRecognizedDocumentKindMismatch";
import { PaxCheckUnknownRecognitionError, PaxCheckUnknownRecognitionErrorFromJSONTyped, PaxCheckUnknownRecognitionErrorToJSON } from "./PaxCheckUnknownRecognitionError";


/**
 * @type PaxCheckRecognizeDocumentError
 * 
 * @export
 */
export type PaxCheckRecognizeDocumentError = { type: 'barcode-to-doc-mismatch' } & PaxCheckBarcodeToDocMismatch | { type: 'document-kind-mismatch' } & PaxCheckRecognizedDocumentKindMismatch | { type: 'document-type-not-supported' } & PaxCheckDocumentTypeNotSupported | { type: 'file-too-large' } & PaxCheckFileTooLarge | { type: 'file-type-not-supported' } & PaxCheckFileTypesNotSupported | { type: 'mrz-to-viz-mismatch' } & PaxCheckMrzToVizMismatch | { type: 'mrz-validation-failed' } & PaxCheckMrzVerificationError | { type: 'no-barcode-scanned' } & PaxCheckNoBarcodeScannedError | { type: 'no-mrz-side-scanned' } & PaxCheckNoMrzSideScannedError | { type: 'not-all-sides-scanned' } & PaxCheckNotAllSidesScannedError | { type: 'unknown-error' } & PaxCheckUnknownRecognitionError;

export function PaxCheckRecognizeDocumentErrorFromJSON(json: any): PaxCheckRecognizeDocumentError {
    return PaxCheckRecognizeDocumentErrorFromJSONTyped(json, false);
}

export function PaxCheckRecognizeDocumentErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckRecognizeDocumentError {
    if (json == null) {
        return json;
    }
    switch (json['type']) {
        case 'barcode-to-doc-mismatch':
            return Object.assign({}, PaxCheckBarcodeToDocMismatchFromJSONTyped(json, true), { type: 'barcode-to-doc-mismatch' } as const);
        case 'document-kind-mismatch':
            return Object.assign({}, PaxCheckRecognizedDocumentKindMismatchFromJSONTyped(json, true), { type: 'document-kind-mismatch' } as const);
        case 'document-type-not-supported':
            return Object.assign({}, PaxCheckDocumentTypeNotSupportedFromJSONTyped(json, true), { type: 'document-type-not-supported' } as const);
        case 'file-too-large':
            return Object.assign({}, PaxCheckFileTooLargeFromJSONTyped(json, true), { type: 'file-too-large' } as const);
        case 'file-type-not-supported':
            return Object.assign({}, PaxCheckFileTypesNotSupportedFromJSONTyped(json, true), { type: 'file-type-not-supported' } as const);
        case 'mrz-to-viz-mismatch':
            return Object.assign({}, PaxCheckMrzToVizMismatchFromJSONTyped(json, true), { type: 'mrz-to-viz-mismatch' } as const);
        case 'mrz-validation-failed':
            return Object.assign({}, PaxCheckMrzVerificationErrorFromJSONTyped(json, true), { type: 'mrz-validation-failed' } as const);
        case 'no-barcode-scanned':
            return Object.assign({}, PaxCheckNoBarcodeScannedErrorFromJSONTyped(json, true), { type: 'no-barcode-scanned' } as const);
        case 'no-mrz-side-scanned':
            return Object.assign({}, PaxCheckNoMrzSideScannedErrorFromJSONTyped(json, true), { type: 'no-mrz-side-scanned' } as const);
        case 'not-all-sides-scanned':
            return Object.assign({}, PaxCheckNotAllSidesScannedErrorFromJSONTyped(json, true), { type: 'not-all-sides-scanned' } as const);
        case 'unknown-error':
            return Object.assign({}, PaxCheckUnknownRecognitionErrorFromJSONTyped(json, true), { type: 'unknown-error' } as const);
        default:
            return json;
    }
}

export function PaxCheckRecognizeDocumentErrorToJSON(json: any): any {
    return PaxCheckRecognizeDocumentErrorToJSONTyped(json, false);
}

export function PaxCheckRecognizeDocumentErrorToJSONTyped(value?: PaxCheckRecognizeDocumentError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['type']) {
        case 'barcode-to-doc-mismatch':
            return Object.assign({}, PaxCheckBarcodeToDocMismatchToJSON(value), { type: 'barcode-to-doc-mismatch' } as const);
        case 'document-kind-mismatch':
            return Object.assign({}, PaxCheckRecognizedDocumentKindMismatchToJSON(value), { type: 'document-kind-mismatch' } as const);
        case 'document-type-not-supported':
            return Object.assign({}, PaxCheckDocumentTypeNotSupportedToJSON(value), { type: 'document-type-not-supported' } as const);
        case 'file-too-large':
            return Object.assign({}, PaxCheckFileTooLargeToJSON(value), { type: 'file-too-large' } as const);
        case 'file-type-not-supported':
            return Object.assign({}, PaxCheckFileTypesNotSupportedToJSON(value), { type: 'file-type-not-supported' } as const);
        case 'mrz-to-viz-mismatch':
            return Object.assign({}, PaxCheckMrzToVizMismatchToJSON(value), { type: 'mrz-to-viz-mismatch' } as const);
        case 'mrz-validation-failed':
            return Object.assign({}, PaxCheckMrzVerificationErrorToJSON(value), { type: 'mrz-validation-failed' } as const);
        case 'no-barcode-scanned':
            return Object.assign({}, PaxCheckNoBarcodeScannedErrorToJSON(value), { type: 'no-barcode-scanned' } as const);
        case 'no-mrz-side-scanned':
            return Object.assign({}, PaxCheckNoMrzSideScannedErrorToJSON(value), { type: 'no-mrz-side-scanned' } as const);
        case 'not-all-sides-scanned':
            return Object.assign({}, PaxCheckNotAllSidesScannedErrorToJSON(value), { type: 'not-all-sides-scanned' } as const);
        case 'unknown-error':
            return Object.assign({}, PaxCheckUnknownRecognitionErrorToJSON(value), { type: 'unknown-error' } as const);
        default:
            return value;
    }
}

